module.exports = __webpack_public_path__ + "static/media/doctor.6434d72c.png";